module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_JP.d21ea43a.txt";